// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 38) return "static/chunks/9aadf96e-6290fa1dcde8a480.js";
	if (chunkId === 907) return "static/chunks/907-e0437fa98c71173f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"594":"da9a67a970e1b208","720":"c3dead668b152aa2"}[chunkId] + ".js";
};